import React, {Component} from "react"
import {X} from "react-feather"
import PerfectScrollbar from "react-perfect-scrollbar"
import classnames from "classnames"

class DataListSidebar extends Component {

    render() {
        let {show, handleSidebar} = this.props
        return (
            <div
                className={classnames("data-list-sidebar", {
                    show: show
                })}>
                <div className="data-list-sidebar-header mt-2 px-2 d-flex justify-content-between">
                    <X size={20} onClick={() => handleSidebar(false, true)}/>
                </div>
                <PerfectScrollbar className="data-list-fields px-2 mt-3" options={{wheelPropagation: false}}>
                    {this.props.view}
                </PerfectScrollbar>
            </div>
        )
    }
}

export default DataListSidebar
